var _path, _rect, _path2, _rect2, _path3, _path4, _g, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUniversityAdmission(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "name-tag",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.74,
    height: 40.74,
    viewBox: "0 0 40.74 40.74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_52929",
    "data-name": "Path 52929",
    d: "M16.86,5H39.7V9.8H16.86Z",
    transform: "translate(-7.912 -5)",
    fill: "#f15d41"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2973",
    "data-name": "Rectangle 2973",
    width: 40.74,
    height: 28.586,
    rx: 3.54,
    transform: "translate(0 12.154)",
    fill: "#91d9b9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_52930",
    "data-name": "Path 52930",
    d: "M45.74,51.46v3.018a2.663,2.663,0,0,1-2.671,2.671H7.671A2.663,2.663,0,0,1,5,54.478V51.46a2.663,2.663,0,0,0,2.671,2.671h35.4A2.663,2.663,0,0,0,45.74,51.46Z",
    transform: "translate(-5 -16.409)",
    fill: "#54b285"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2974",
    "data-name": "Rectangle 2974",
    width: 14.335,
    height: 4.527,
    rx: 2.263,
    transform: "translate(13.203 15.089)",
    fill: "#54b285"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_52931",
    "data-name": "Path 52931",
    d: "M10.5,35H24.835V49.334H10.5Z",
    transform: "translate(-6.351 -12.367)",
    fill: "#fee253"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_52932",
    "data-name": "Path 52932",
    d: "M10.5,49.88H24.835V53H10.5Z",
    transform: "translate(-6.351 -16.021)",
    fill: "#fab915"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_45609",
    "data-name": "Group 45609",
    transform: "translate(7.197 23.463)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52933",
    "data-name": "Path 52933",
    d: "M34.25,36.1H48.773v1.509H34.25Z",
    transform: "translate(-19.38 -36.1)",
    fill: "#3f505a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52934",
    "data-name": "Path 52934",
    d: "M34.25,41.03H48.773v1.509H34.25Z",
    transform: "translate(-19.38 -37.311)",
    fill: "#3f505a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52935",
    "data-name": "Path 52935",
    d: "M34.25,45.97H48.773v1.509H34.25Z",
    transform: "translate(-19.38 -38.524)",
    fill: "#3f505a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52936",
    "data-name": "Path 52936",
    d: "M34.25,50.9H48.773v1.509H34.25Z",
    transform: "translate(-19.38 -39.734)",
    fill: "#3f505a"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2659",
    "data-name": "Ellipse 2659",
    cx: 2.505,
    cy: 2.505,
    rx: 2.505,
    ry: 2.505,
    transform: "translate(1.615 1.728)",
    fill: "#3f505a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52937",
    "data-name": "Path 52937",
    d: "M22.779,49.719v2.663H14.54V49.719a2.309,2.309,0,0,1,2.309-2.309H20.47A2.309,2.309,0,0,1,22.779,49.719Z",
    transform: "translate(-14.54 -38.877)",
    fill: "#3f505a"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_52938",
    "data-name": "Path 52938",
    d: "M9.02,24.69h5.621V26.2H9.02Z",
    transform: "translate(-5.987 -9.835)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_52939",
    "data-name": "Path 52939",
    d: "M17.64,24.69h1.781V26.2H17.64Z",
    transform: "translate(-8.104 -9.835)",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_52940",
    "data-name": "Path 52940",
    d: "M20.044,5l4.8,4.8H16.86V5Z",
    transform: "translate(-7.912 -5)",
    fill: "#d33529"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_52941",
    "data-name": "Path 52941",
    d: "M44.54,5V9.8H36.55L41.356,5Z",
    transform: "translate(-12.747 -5)",
    fill: "#d33529"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_52942",
    "data-name": "Path 52942",
    d: "M45.389,7.9l-9.831,9.838-4.5,4.5-2.9-2.9,2.9-2.9,1.6-1.6L37.694,9.8l4.8-4.8Z",
    transform: "translate(-10.684 -5)",
    fill: "#f15d41"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_52943",
    "data-name": "Path 52943",
    d: "M35.559,20.935l-4.5,4.5-2.9-2.9,2.9-2.9,1.6-1.6Z",
    transform: "translate(-10.684 -8.2)",
    fill: "#d33529"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_52944",
    "data-name": "Path 52944",
    d: "M30.239,19.334l-2.9,2.9-2.9-2.9L13,7.9,15.9,5,27.335,16.43Z",
    transform: "translate(-6.964 -5)",
    fill: "#f15d41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUniversityAdmission);
export default __webpack_public_path__ + "static/media/university-admission.fdb896c549a348ffbb47e12e98082fbd.svg";
export { ForwardRef as ReactComponent };